export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const computePositionFromValue = (value, totalItems) => {
  const v = clamp(parseFloat(value) || 1, 1, 10);
  return Math.round(((v - 1) * (totalItems - 1)) / 9 + 1);
};

export const computeValueFromPosition = (position, totalItems, decimals = 0) => {
  const p = clamp(parseInt(position, 10) || 1, 1, totalItems);
  const raw = ((p - 1) * 9) / (totalItems - 1) + 1;
  return parseFloat(raw.toFixed(decimals));
};

export const sliderPercent = (value) => `${(((value - 1) / 9) * 100)}`;


